export default theme => ({
  icon: {
    margin: theme.spacing.unit,
    fontSize: 64
  }
});
